export default {
    CONSIGNED(state, items) {
        state.items = items
    }
}